import { render } from "./StudentDetails.vue?vue&type=template&id=d6b06e32&scoped=true"
import script from "./StudentDetails.vue?vue&type=script&lang=js"
export * from "./StudentDetails.vue?vue&type=script&lang=js"

import "./StudentDetails.vue?vue&type=style&index=0&id=d6b06e32&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6b06e32"]])

export default __exports__